import React from 'react';
import {
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import Text from '../../../components/Text';
import TextInput, {
  filterNumericKeyPress, generatePhoneNumberHandler,
} from '../../../components/TextInput';

import industryCodes from './employment-industry-codes.json';
import jobCodes from './employment-job-codes.json';

export default function LeadsEmploymentView(props) {
  return (
    <>
      <TextInput
        name="workPhone"
        label="Work Phone"
        validationData={props.validations}
        formData={props.formData}
        onChange={generatePhoneNumberHandler(props.onChange, props.formData.workPhone)}
        type="tel"
        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
        maxLength="12"
        helpText="###-###-####"
        required
        onKeyPress={filterNumericKeyPress}
      />
      <TextInput
        name="workPhoneExt"
        label="Work Phone Extension"
        validationData={props.validations}
        formData={props.formData}
        onChange={props.onChange}
      />
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="industryCode">
              <Text value="What industry do you work in" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="industryCode"
          id="industryCode"
          value={props.formData.industryCode}
          onChange={props.onChange}
          invalid={props.validations.industryCode?.isInvalid}
        >
          <option value="">Select your industry</option>
          {
            industryCodes.map((i) => (
              <option key={`industry${i.value}`} value={i.value}>
                { i.name }
              </option>
            ))
          }
        </Input>
        <FormFeedback>{ props.validations.industryCode?.message }</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="jobCode">
              <Text value="What type of job do you have" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="jobCode"
          id="jobCode"
          value={props.formData.jobCode}
          onChange={props.onChange}
          invalid={props.validations.jobCode?.isInvalid}
        >
          <option value="">Select your job</option>
          {
            jobCodes.map((i) => (
              <option key={`job${i.value}`} value={i.value}>
                { i.name }
              </option>
            ))
          }
        </Input>
        <FormFeedback>{ props.validations.jobCode?.message }</FormFeedback>
      </FormGroup>
    </>
  );
}
